<template>
  <div class="wisdom_card">
    <div class="card_title">
      <span :class="icon"></span>
      {{ title }}
    </div>
    <div class="card_content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "wisdom_card",
  props: {
    title: {
      type: String,
      default: "",
    },
    icon: {
      type: String,
      default: "",
    },
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {},
  watch: {},
  mounted() {},
};
</script>

<style lang="scss" scoped>
.wisdom_card {
  display: flex;
  flex-direction: column;
  border: solid 1px #e6e6e6;
  background: white;
  .card_title {
    background: #2c86d1;
    color: white;
    height: 40px;
    line-height: 40px;
    padding: 0 10px;
  }
  .card_content {
    flex: 1;
  }
}
</style>
